var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgReplyHoveredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34609 14.2537L0.84375 8.25187L8.34609 2.25V6.00117C12.4896 6.00117 15.8484 9.35997 15.8484 13.5035C15.8484 13.7083 15.8409 13.9109 15.8244 14.1112C15.2516 13.022 14.3918 12.1101 13.3382 11.4741C12.2847 10.838 11.0772 10.5021 9.84656 10.5026H8.34609V14.2537Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgReplyHoveredIcon);
export default __webpack_public_path__ + "static/media/msg-reply-hovered-icon.89a76d59f8a7dd7575fd08593d0e07de.svg";
export { ForwardRef as ReactComponent };